// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BIIw","index":"styles_index__1gNjY"};